module.exports = __webpack_public_path__ + "static/media/6.334894f3.png";